import React, { useContext } from 'react';

import DocumentContext from '../DocumentPage/DocumentContext';
import { GoogleAdsTemplate } from './GoogleAdsTemplate';

export const AdsBelowReader: React.FC = () => {
    const {
        publisher: {
            licenses: { docpageAds },
        },
    } = useContext(DocumentContext);

    const adSizes = docpageAds
        ? [
              [300, 250],
              [300, 100],
              [320, 50],
          ]
        : [
              [300, 250],
              [320, 100],
              [320, 50],
              [300, 50],
          ];

    return (
        <GoogleAdsTemplate
            adSizes={adSizes}
            idSuffix="belowReader"
            isShowInnerTitle={true}
            network={
                docpageAds
                    ? '/30443627/DocPage_PrimaryMob_BelowReader_adConnect'
                    : '/30443627/DocPage_PrimaryMob_BelowReader'
            }
        />
    );
};
